var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',{attrs:{"title":"会社情報","icon":"fas fa-cogs"}},[_c('company-settings')],1)}
var staticRenderFns = []

export { render, staticRenderFns }